import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class OmsOrderFulfillmentLineNotesComponent implements IController {

  order: any;

  public notes: string[];

  constructor() {
  }

  $onInit() {
    this._initNotes();
  }

  $onChanges(changes) {
    if (changes.order && !changes.order.isFirstChange()) {
      this.$onInit();
    }
  }

  private _initNotes() {
    this.notes = _.map(_.get(this.order, 'internalNotes', []), (externalNote) => {
      return externalNote.text;
    });
    _.forEach(this.order.fulfillmentLines, l => {
      if(l.pickupTask && l.pickupTask.notes){
        this.notes.push(l.pickupTask.notes);
      }
      if(l.destinationTask && l.destinationTask.notes){
        this.notes.push(l.destinationTask.notes);
      }
    });
  }
}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderFulfillmentLineNotes', {
    bindings: {
      order: '<',
    },
    template: require('./oms-order-fulfillment-line-notes.html').default,
    controller: OmsOrderFulfillmentLineNotesComponent
  });
